export const reminderTypes = [
  { value: null, label: 'No Reminder', time: 0, type: null },
  { value: 1, label: '15 min Before', time: 15, type: 'minutes' },
  { value: 2, label: '30 min Before', time: 30, type: 'minutes' },
  { value: 3, label: '45 min Before', time: 45, type: 'minutes' },
  { value: 4, label: '1 h Before', time: 1, type: 'hours' },
  { value: 5, label: '2 h Before', time: 2, type: 'hours' },
  { value: 6, label: '3 h Before', time: 3, type: 'hours' },
  { value: 7, label: '4 h Before', time: 4, type: 'hours' },
  { value: 8, label: '5 h Before', time: 5, type: 'hours' },
  { value: 9, label: '6 h Before', time: 6, type: 'hours' },
  { value: 10, label: '7 h Before', time: 7, type: 'hours' },
  { value: 11, label: '8 h Before', time: 8, type: 'hours' },
  { value: 12, label: '9 h Before', time: 9, type: 'hours' },
  { value: 13, label: '10 h Before', time: 10, type: 'hours' },
  { value: 14, label: '11 h Before', time: 11, type: 'hours' },
  { value: 15, label: '12 h Before', time: 12, type: 'hours' },
  { value: 16, label: '1 day Before', time: 1, type: 'days' },
  { value: 17, label: '2 days Before', time: 2, type: 'days' },
  { value: 18, label: '3 days Before', time: 3, type: 'days' },
  { value: 19, label: '4 days Before', time: 4, type: 'days' },
  { value: 20, label: '1 week Before', time: 7, type: 'days' },
  { value: 21, label: '2 weeks Before', time: 14, type: 'days' },
  { value: 22, label: '3 weeks Before', time: 21, type: 'days' },
  { value: 23, label: '1 month Before', time: 1, type: 'months' },
]

export const getValueForReminder = (value) => {
  const reminderOptions = new Map()

  reminderTypes.forEach((i) => {
    reminderOptions.set(i.value, i)
  })

  return reminderOptions.get(value)
}
